import api from "../services/api";
import { getToken } from "../utils/storage";

export const login = ({ email, password }) => {
    return api.post('company/auth/login', {
        email,
        password
    }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const forgotPassword = ({ email }) => {
    return api.post('company/auth/forgot_password', {
        email
    }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const verifyOtp = ({ email, otp }) => {
    return api.post('company/auth/verify_otp', {
        email,
        otp
    }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const resetPassword = ({ email, new_password, otp }) => {
    return api.post('company/auth/reset_password', {
        email,
        new_password,
        otp
    }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const setNewPassword = ({ company_id, new_password }) => {
    return api.post('admin/auth/company/reset_password', {
        company_id,
        new_password
    }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const register = (formData) => {
    return api.post('company/auth/register',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
}

export const registerOtp = (data) => {
    return api.post('/company/auth/register_otp',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

// Logout
export const logout = () => {
    return api.post('company/auth/logout', {}, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const GetCompanyById = (queryParams) => {
    return api.get(`company/auth/details/get${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        },
    });
};

// with token
export const getCurrentUser = () => {
    return api.get('company/auth/details', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        },
    });
};

export const update = (formData) => {
    return api.put('company/auth/profile',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const changePassword = (data) => {
    return api.post('company/auth/change_password',
        { ...data },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`
            }
        });
}